import { Form } from "react-bootstrap";
import { groupMoney, unformatMoney } from "../utils/moneyFormat";

/**
 * Ô nhập số tiền hiển thị phân cách hàng nghìn bằng dấu phẩy khi gõ,
 * nhưng trả về chuỗi số thuần (không phẩy) qua onValueChange.
 *
 * @param {string|number} value    giá trị số thuần (không phẩy)
 * @param {(raw:string)=>void} onValueChange  nhận chuỗi số thuần
 */
const MoneyInput = ({
  value,
  onValueChange,
  size,
  placeholder,
  disabled = false,
  required = false,
  className,
  id,
  name,
  ...rest
}) => (
  <Form.Control
    type="text"
    inputMode="numeric"
    size={size}
    id={id}
    name={name}
    className={className}
    placeholder={placeholder}
    disabled={disabled}
    required={required}
    value={groupMoney(value)}
    onChange={(e) => onValueChange?.(unformatMoney(e.target.value))}
    {...rest}
  />
);

export default MoneyInput;
